import PiadaOneApi from './PiadaOneApi';
import Location from '../classes/Location';
import { plainToClass } from 'class-transformer';
import axios from 'axios';

import { useUserStore } from '../stores/user'

export default {
  getAll(): Promise<any> {
    const userStore = useUserStore()

    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/locations',
        {
          headers: {
            'X-User-Verify': 'header'
          }
        },
      ).then((response) => {
        let locs = [] as Location[];
        if (response.status === 200 && response.data && typeof(response.data) != "string") {
          const jsonObjs = response.data as Location[];
          locs = jsonObjs.map(
            (loc) => plainToClass(Location, (loc as object), { excludeExtraneousValues: true }),
          );
          resolve(locs);
        } else {
          if (typeof(response.data) == "string") {
            // Just return it
            reject(new Error(response.data))
          } else if(response.data && response.data.message) {
            reject(new Error(response.data.message))
          } else if(response.data && response.data.error) {
            reject(new Error(response.data.error))
          } else {
            reject(new Error('An error has occurred. Please try again later.'));
          }
        }
      }).catch((error: any) => {
        if (axios.isAxiosError(error)) {
          // Do something with this error...
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          } else if (error.response && error.response.data && typeof(error.response.data) == "string") {
            reject(new Error(error.response.data))
          } else {
            reject(error);
          }
        } else {
          reject(error);
        }
      });
    });
  },
};
